import {
  Descriptions,
  Table,
  Button,
  Modal,
  message,
  Tag,
  Space
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import "./Edit.scss";
import {
  HomeOutlined,
  ExclamationCircleOutlined,
  RollbackOutlined
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import moment from "moment";
import { useNavigate, useLocation } from 'react-router-dom';
import { CustomUploadNew } from "@/hocComponents";
import { majorProjectAPStatusDictFn } from "@/utils/dict";
import SubContractModal from "./Edit/subContractModal";
import TradeModal from "./Edit/tradeModal";
import TradeLinkPaidPayments from "./Edit/tradeLinkPaidPayments";
import ParamEditModal from "./Edit/ParamEditModal" ;
import commonFn from "@/utils/commonFn";

export default function ContractorEdit() {
  const [propContractorId, setPropContractorId] = useState(null);
  const [detail, setDetail] = useState({});
  const [interfaceData, setInterfaceData] = useState({})
  const [filedModalFlag, setFiledModalFlag] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [filePaths, setFilePaths] = useState([]);
  const customUploadNewRef = useRef(null);
  const [viewFlag, setViewFlag] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const getDetailFn = async(propsId) => {
    setViewFlag(false)
    const id = propsId || propContractorId
    const response = await http.get(api.getContractDetail, {params: {id}});
    if (response.code == 1) {
      setInterfaceData(response.data)
      const {contract, project} = response.data
      const list = (contract?.fileList || [])?.map(item => ({ ...item, url: item.allPath, baseUrl: item.allPath, name: item.name || item.fileName, type: item.contentType}))
      const {propId, projectName, unitId, unitName, propName, projectManger, createTime  } = project
      const {projectIdStr, contractor, expectedCompleteTime, amount, createByName, co, payAmount, contractDate, remainingAmount, commenceDate, contractedAmount, fileList, contractedOtherAmount, grandTotal } = contract
      setDetail({
        propId,
        'Project Name': projectName,
        'Project Number': projectIdStr,
        // 'Contractor Name': contractor,
        'Address': (unitId && unitId !== -1) ? unitName : propName,
        'Completion Date': moment(expectedCompleteTime).format("MM/DD/YYYY"),
        'Project Manager': projectManger,
        'Original Contract': commonFn.amountToDollarFn(amount),
        'Original Contract Temp': amount,
        'Created By': createByName,
        'Change Order': commonFn.amountToDollarFn(co),
        'Created Date': moment(createTime).format("MM/DD/YYYY"),
        'Total Paid': commonFn.amountToDollarFn(payAmount),
        'Contract Date': moment(contractDate).format("MM/DD/YYYY"),
        'Remaining': commonFn.amountToDollarFn(remainingAmount),
        'Commence Date': moment(commenceDate).format("MM/DD/YYYY"),
        'Total Contract + COs': commonFn.amountToDollarFn(contractedAmount),
        'File': fileList || [],
        'Total Other Paid': commonFn.amountToDollarFn(contractedOtherAmount),
        'Total Major Project Cost': commonFn.amountToDollarFn(grandTotal),
        'fileList': list
      })
      setViewFlag(true)
      setTradeLinkPaidPaymentsDisable(false)
    }
  }

  const paramEditModalRef = useRef(null);
  const [paramEditRecord, setParamEditRecord] = useState({});

  const paramEditModalSubmitlFn = (params) => {
    getDetailFn(interfaceData?.contract?.id)
  }
  

  const mainRef = useRef(null);
  const [subContractScroll, setSubContractScroll] = useState({
    subContractX: 0,
    subContractY: 0,
    tradeX: 0,
    tradeY: 0,
  });
  
  const getTableHeightFn = () => {
    const otherHeight = 55 + 5 + (10 + 24 * 3) + (28 + 16) + (2 + 32) // 220
    const mainContractHeight = (23 + 22 + 18) + (2+ 32 + 49) + 43 // 189
    const btnListHeight = 32 + 16
    const mainHeight = mainRef.current.offsetHeight
    const width = (window.innerWidth - 220 - 80 - 50) / 5 
    const subContractX = width * 2 - 26 - 50
    const tradeX = width * 3 - 24 - 24 - 24
    const subContractY = window.innerHeight - mainHeight - otherHeight - mainContractHeight
    const tradeY = window.innerHeight - otherHeight - btnListHeight - 40 // 40兼容
    setSubContractScroll({
      subContractX,
      subContractY,
      tradeX,
      tradeY,
    })
  }

  useEffect(() => {
    const id = new URLSearchParams(location.search).get('id')
    setPropContractorId(id)
    getDetailFn(id)
    getSubContractListFn(id)
    getTradeListFn(id)
    getTableHeightFn()
  }, [])

  const deleteOldFn = async(file) => {
    let flag = false
    const response = await http.get(api.delContractFile, { params: {id: file.id} });
    if (response.code === "1") {
      flag = true
    }
    return flag
  }

  const submitContractFileFn = async() => {
    const fileList = filePaths.filter(item => !item.id)
    if(!fileList?.length){
      setFiledModalFlag(false)
      return
    }
    setBtnLoading(true)
    const response = await http.post(api.saveContractFile, {
      id: propContractorId,
      fileList
    });
    if (response.code === "1") {
      message.success("Updated successfully");
      setFiledModalFlag(false)
    } else {
      message.error(response.msg);
    }
    setBtnLoading(false)
  }

  const mainContractDocFn = () => {
    const list = [
      'Project Number',
      // 'Contractor Name',
      'Completion Date',
      'Address',
      'Original Contract',
      'Project Manager',
      'Change Order',
      'Created By',
      'Total Contract + COs',
      'Created Date',
      'Total Paid',
      'Contract Date',
      'Remaining',
      'Commence Date',
      'Total Other Paid',
      'File',
      // '',
      'Total Major Project Cost',
     ]
    const items =  list.map(item => {
      if(item === 'File'){
        return {
          label: item,
          children: detail?.['propId'] && (
            <Button
              disabled={!viewFlag}
              type="link"
              onClick={() => setFiledModalFlag(true)}
              style={{textDecoration: 'underline', fontSize: '14px', height:'unset', color: '#4E633B', padding: 0}}
            >
              View
            </Button>
          ) || null
        }
      }
      if(['Completion Date', 'Contract Date', 'Commence Date'].includes(item)){
        return {
          label: item,
          children: (
            <Button
              disabled={!viewFlag}
              type="link"
              onClick={(e) => {
                e.preventDefault();
                setParamEditRecord({...detail, id: interfaceData?.contract?.id})
                paramEditModalRef.current.openModal(true)
              }}
              style={{textDecoration: 'underline', fontSize: '14px', height:'unset', color: '#4E633B', padding: 0}}
            >
              {detail?.[item]}
            </Button>
          ) || null
        }
      }
      if(item === 'Created By'){
        const arr = detail?.[item]?.split(/,(.+)/)
        const str1 = arr?.[0]
        const str2 = arr?.[1]
        const result = arr?.length && (
          <>
            <div>{str1}</div>
            {str2 && <div>{str2}</div> || null}
          </>
        )
        return {
          label: item,
          children: result,
        }
      }
      return {
        label: item,
        children: detail?.[item] || null,
      }
    })
    return (
      <Descriptions 
        title={`Major Project: ${detail?.['Project Name'] || ''}`}
        className="contractorDescriptions"
        size="small"
        column={2}
        items={items} 
      />
    )
  }

  const subContractRef = useRef(null);
  const [subContractDataList, setSubContractDataList] = useState([]);
  const [subContractLoading, setSubContractLoading] = useState(false);
  const [subContractRowKey, setSubContractRowKey] = useState([]);
  const [subContractApproveDisable, setSubContractApproveDisable] = useState(false);
  const [subContractEditDisable, setSubContractEditDisable] = useState(false);
  const [subContractDeleteDisable, setSubContractDeleteDisable] = useState(false);
  
  const tradeRef = useRef(null);
  const tradeLinkPaidPaymentsRef = useRef(null);
  const [tradeDataList, setTradeDataList] = useState([]);
  const [tradeLoading, setTradeLoading] = useState(false);
  const [tradeRowKey, setTradeRowKey] = useState([]);
  const [tradeApproveDisable, setTradeApproveDisable] = useState(false);
  const [tradeEditDisable, setTradeEditDisable] = useState(false);
  const [tradeDeleteDisable, setTradeDeleteDisable] = useState(false);
  const [tradeLinkPaidPaymentsDisable, setTradeLinkPaidPaymentsDisable] = useState(true);
  const [selectRows, setSelectRows] = useState({});

  const subContractBtnList = (subContractApproveDisable = false, subContractEditDisable = false, subContractDeleteDisable = false) => {
    return (
      [
        {
          label: 'New Change Order',
          icon: 'add',
          type: 'subContractAdd',
          authKey: 'NewChangeOrder',
          modalName: 'New Change Order'
        },
        {
          label: 'Approve',
          icon: 'approve',
          type: 'subContractApprove',
          authKey: 'ApproveChangeOrder',
          modalName: 'Change Order',
          disabled: subContractApproveDisable
        },
        {
          label: 'View',
          icon: 'view',
          type: 'subContractView',
          authKey: 'ViewChangeOrder',
          modalName: 'View Change Order'
        },
        {
          label: 'Edit',
          icon: 'edit',
          type: 'subContractEdit',
          authKey: 'EditChangeOrder',
          modalName: 'Edit Change Order',
          disabled: subContractEditDisable
        },
        {
          label: 'Delete',
          icon: 'delete',
          type: 'subContractDelete',
          authKey: 'DeleteChangeOrder',
          disabled: subContractDeleteDisable
        }
      ]
    )
  }

  const tradeBtnList = (tradeApproveDisable = false, tradeEditDisable = false, tradeDeleteDisable = false, tradeLinkPaidPaymentsDisable = true) => {
    return (
      [
        {
          label: 'New Payment Request',
          icon: 'add',
          type: 'tradeAdd',
          authKey: 'NewPaymentRequest',
          modalName: 'New Payment Request'
        },
        {
          label: 'Send For Approval',
          icon: 'send',
          type: 'tradeSend',
          authKey: 'SendForApproval',
          modalName: 'Payment Request',
          disabled: tradeApproveDisable
        },
        // {
        //   label: 'View',
        //   icon: 'view',
        //   type: 'tradeView',
        //   authKey: 'ViewPaymentRequest',
        //   modalName: 'View Payment Request',
        // },
        {
          label: 'Edit',
          icon: 'edit',
          type: 'tradeEdit',
          authKey: 'EditPaymentRequest',
          modalName: 'Edit Payment Request',
          disabled: tradeEditDisable
        },
        {
          label: 'Delete',
          icon: 'delete',
          type: 'tradeDelete',
          authKey: 'DeletePaymentRequest',
          disabled: tradeDeleteDisable
        },
        {
          label: 'Link Paid Payments',
          icon: 'edit',
          type: 'tradeLinkPaidPayments',
          authKey: 'LinkPaidPayments',
          modalName: 'Link Paid Payments',
          disabled: tradeLinkPaidPaymentsDisable
        },
        {
          label: 'Link Other Payments',
          icon: 'edit',
          type: 'tradeLinkPaidPayments',
          authKey: 'LinkOtherPayments',
          modalName: 'Link Other Payments',
          disabled: tradeLinkPaidPaymentsDisable
        },
      ]
    )
  }

  const secondConfirmFn = (type = "subContractDelete") => {
    const statusMatch = {
      1: 5,
      2: 3,
      4: 6,
      // 5: 6,
      9: 103,
      10: 102,
      201: 104,
      202: 104
    }
    const typeMatch = {
      "subContractDelete": {
        title: 'Delete Change Order',
        url: api.delSub,
        id: subContractRowKey[0],
        fnType: 'get',
        fn: subContractModalSubmitFn
      },
      "tradeDelete": {
        title: 'Delete Trade',
        url: api.updateRecordStatus,
        id: tradeRowKey[0],
        status: statusMatch[selectRows.status],
        fnType: 'post',
        fn: () => tradeModalSubmitFn()
      },
    }
    const item = typeMatch[type]
    Modal.confirm({
      title: item.title,
      icon: <ExclamationCircleOutlined />,
      content: `Are you sure you want to delete the selected data?`,
      okText: 'Sure',
      cancelText: 'Cancel',
      onOk: async() => {
        const {url, id, status, fnType, fn} = item
        const obj = fnType === 'get' ? {
          params: {id}
        } : {
          id, 
          status
        }
        const response = await http[fnType](url, obj);
        if (response.code === "1") {
          message.success('Deleted successfully');
          fn()
        } else {
          setTimeout(() => {
            commonFn.modalFailedFn(response)
          }, 500);
        }
      },
      onCancel() {
        console.log('Cancel');
      },
      style: {
        top: '40%',
      },
    });
  }

  const btnListClickFn = (item) => {
    const {type, icon, modalName} = item
    const subContractFlag = ['subContractApprove', 'subContractView', 'subContractEdit', 'subContractDelete'].includes(type) && !subContractRowKey.length
    const tradeFlag = ['tradeSend', 'tradeView', 'tradeEdit', 'tradeDelete'].includes(type) && !tradeRowKey.length
    if(subContractFlag || tradeFlag){
      message.warning("Please select at least one item.");
      return
    }
    switch (type) {
      case 'subContractAdd':
      case 'subContractApprove':
      case 'subContractView':
      case 'subContractEdit':
        subContractRef.current.openModal(icon, modalName)
        break;
      case 'subContractDelete':
        secondConfirmFn(type)
        break;
      case 'tradeAdd':
      case 'tradeSend':
      case 'tradeView':
      case 'tradeEdit':
        const {id: statusId, colorStr} = selectRows
        tradeRef.current.openModal({
          type: icon,
          modalName,
          statusId,
          colorStr,
        })
        break;
      case 'tradeDelete':
        secondConfirmFn(type)
        break;
      case 'tradeLinkPaidPayments':
        tradeLinkPaidPaymentsRef.current.openModal(icon, modalName)
        break;
      default:
        break;
    }
  }

  const btnListDocFn = ({btnList, borderFlag, amountFlag}) => {
    return (
      <div className={`btnList ${borderFlag ? 'border' : ''}`} >
        {
          btnList.map(item => (
          <commonFn.BtnAuthorityFn authKey={item.authKey}>
            <Button 
              className="btnItem" 
              onClick={() => btnListClickFn(item)}
              icon={
                <img className="img" src={require(`@/assets/images/contractor/${item.icon}.png`)} alt="" />
              }
              disabled={item.disabled}
            >{item.label}
            </Button>
          </commonFn.BtnAuthorityFn>
          ))
        }
        {/* {
          amountFlag && (
            <div className="amount">{`Remaining: ${detail?.Remaining || ''}`}</div>
          ) || null
        } */}
      </div>
    )
  }

  const getSubContractListFn = async(id) => {
    setSubContractLoading(true)
    const contractId = id || propContractorId
    const response = await http.post(`${api.getSubList}`, {
      contractId
    });
    if (response.code === "1") {
      setSubContractDataList(response.data || [])
      setSubContractRowKey([])
      setSubContractApproveDisable(false)
      setSubContractDeleteDisable(false)
    }
    setSubContractLoading(false)
  }

  const subContractModalSubmitFn = () => {
    getSubContractListFn()
    getDetailFn()
  }

  const tradeModalSubmitFn = () => {
    getTradeListFn()
    getSubContractListFn()
    getDetailFn()
  }

  const getTradeListFn = async(id) => {
    setTradeLoading(true)
    const contractId = id || propContractorId
    const response = await http.post(`${api.getAdminRecordList}`, {
      contractId
    });
    if (response.code === "1") {
      setTradeDataList(response.data || [])
      setTradeRowKey([])
      setTradeApproveDisable(false)
      setTradeEditDisable(false)
      setTradeDeleteDisable(false)
    }
    setTradeLoading(false)
  }

  const subContractColumns = [
    {
      title: '#',
      dataIndex: '',
      key: '',
      align: "center",
      width: 80,
      render: (_, __, index) => index + 1,
    },
    {
      title: 'Status',
      dataIndex: 'approvalType',
      key: 'approvalType',
      align: "center",
      width: 80,
      render: (text, record) => {
        const approvalTypeMatch = {
          0: {
            label: 'Pending',
            color: 'blue'
          },
          1: {
            label: 'Approved',
            color: 'green'
          },
          2: {
            label: 'Rejected',
            color: 'red'
          },
          3: {
            label: 'Admin deleted',
            color: 'red'
          },
          4: {
            label: 'Contractor deleted',
            color: 'red'
          },
        }
        const item = approvalTypeMatch[text  || 0]
        return (
          <Tag 
            color={item.color} 
            onClick={() => subContractRef.current.openModal('view', 'View Change Order', record.id)}
            style={{cursor: 'pointer'}}
          >
            {item.label}
          </Tag>
        )           
      },
    },
    {
      title: 'Created By',
      dataIndex: 'createName',
      key: 'createName',
      align: "center",
    },
    {
      title: 'C.O Name',
      dataIndex: 'subName',
      key: 'subName',
      align: "center",
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      align: "center",
      render: (text) => commonFn.amountToDollarFn(text),
    },
  ]

  const tradeColumns = [
    {
      title: '#',
      dataIndex: '',
      key: '',
      align: "center",
      width: 50,
      render: (_, __, index) => index + 1,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      align: "center",
      width: 100,
      render: (text, record) => {
        const {id: statusId, colorStr} = record
        const { statusMatchObj } = majorProjectAPStatusDictFn({text, record})
        return (
          <Tag 
            color={statusMatchObj.color} 
            onClick={() => tradeRef.current.openModal({
              type: 'view',
              modalName: 'View Payment Request',
              statusId,
              colorStr,
            })}
            style={{
              cursor: 'pointer',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              textAlign: 'center'
            }}
          >
            {statusMatchObj.label}
          </Tag>
        )     
      },
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      align: "center",
      width: 80,
      render: (text, record) => {
       return (
        <span
          style={{
            color: record?.colorStr || "#3c8dbc",
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          }}
        >
          {`${commonFn.amountToDollarFn(text)}${(record?.colorStr == "#f39c12") && '(V)' || ''}`}
        </span>
       )
      },
    },
    {
      title: "GL-Title",
      dataIndex: "glTitle",
      titleType: "Input",
      width: 100,
    },
    {
      title: 'Remark',
      dataIndex: "remark",
      titleType: 'Input',
      width: 100,
    },
    {
      title: 'Vendor',
      dataIndex: "recordVendorName",
      titleType: 'Input',
      width: 90,
    },
    {
      title: 'Payment Type',
      dataIndex: 'recordType',
      key: 'recordType',
      align: "center",
      width: 90,
      render: (text) => {
        const recordTypeMatch = {
          1: 'Major Project',
          2: 'Other Payment',
        }
        return recordTypeMatch[text || 1]        
      },
    },
    {
      title: 'Last Update Date',
      dataIndex: "createTime",
      key: "createTime",
      align: "center",
      width: 100,
      render: (text, record) => {
        const {isColor, checkDate} = record
        return moment(isColor ? checkDate : text).format("MM/DD/YYYY")
      },
    },
  ]

  const tableDocFn = ({ columns, dataList, loading, maxWidth, scrollY, selectedRowKeys, onChange, type}) => {
    const flag = type === 'trade'
    return (
      <Table
        className="contractorTable"
        style={{
          maxWidth: `${maxWidth}px`
        }}
        columns={columns} 
        dataSource={dataList}
        loading={loading}
        pagination={false}
        rowKey={'id'}
        tableLayout={flag ? "fixed" : "auto"}
        scroll={{
          x: flag ? 710 : 'max-content',
          y: scrollY
        }}
        rowSelection={{ 
          type: 'radio',
          selectedRowKeys,
          onChange,
        }}
      />
    )
  }

  return (
    <div className="ContractorEdit">
      <div className="title">
        {new URLSearchParams(location.search).get('projectName')}
        {/* <div className="back">
          <Button icon={<RollbackOutlined />} onClick={() => navigate('/JobRequests/MajorProject')}>Back</Button>
        </div> */}
        </div>
      <div className="content">
        <div className="mainAndSub">
          <div className="main" ref={mainRef}>
            {mainContractDocFn()}
          </div>
          <div className="sub">
            <div className="subTitle">Change Order</div>
            <div className="subContent">
              {
                btnListDocFn({
                  btnList: subContractBtnList(subContractApproveDisable, subContractEditDisable, subContractDeleteDisable),
                  borderFlag: true,
                })
              }
              {
                tableDocFn({
                  columns: subContractColumns,
                  dataList: subContractDataList,
                  loading: subContractLoading,
                  maxWidth: subContractScroll.subContractX,
                  scrollY: subContractScroll.subContractY,
                  selectedRowKeys: subContractRowKey,
                  onChange: (selectedRowKeys, selectedRows) => {
                    setSubContractRowKey(selectedRowKeys)
                    const {isApprove, isEdit, isDelete} = selectedRows[0]
                    setSubContractApproveDisable(!isApprove)
                    setSubContractEditDisable(!isEdit)
                    setSubContractDeleteDisable(!isDelete)
                  },
                  type: 'subContract'
                })
              }
            </div>
          </div>
        </div>
        <div className="trade">
          {btnListDocFn({
            btnList: tradeBtnList(tradeApproveDisable, tradeEditDisable, tradeDeleteDisable, tradeLinkPaidPaymentsDisable),
            amountFlag: true
          })}
          {
            tableDocFn({
              columns: tradeColumns,
              dataList: tradeDataList,
              loading: tradeLoading,
              maxWidth: subContractScroll.tradeX,
              scrollY: subContractScroll.tradeY,
              selectedRowKeys: tradeRowKey,
              onChange: (selectedRowKeys, selectedRows) => {
                setTradeRowKey(selectedRowKeys)
                const {isApprove, isEdit, isDelete} = selectedRows[0]
                setTradeApproveDisable(!isApprove)
                setTradeEditDisable(!isEdit)
                setTradeDeleteDisable(!isDelete)
                setSelectRows(selectedRows[0])
              },
              type: 'trade'
            })
          }
        </div>
      </div>

      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <HomeOutlined style={{ marginRight: "8px" }} />
            File
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={filedModalFlag}
        onCancel={() => setFiledModalFlag(false)}
        footer={null}
        maskClosable={false}
        // destroyOnClose={true}
        width="80%"
        afterOpenChange={flag => {
          if(flag){
            customUploadNewRef.current.initUpdateList(detail.fileList)
          }else{
            getDetailFn()
          }
        }}
      >
        <CustomUploadNew
          ref={(el) => (customUploadNewRef.current = el)}
          customConfig={{
            accept: ".jpg, .jpeg, .png, .pdf",
            status: 'add',
            deleteOldFn: deleteOldFn
          }}
          setFilePaths={setFilePaths} 
          filePaths={filePaths} 
          setBtnDisabled={setBtnDisabled}
          btnDisabled={btnDisabled}
        />
        <div style={{textAlign:'center'}}>
          <Space align="center">
            <Button key="back" onClick={() => setFiledModalFlag(false)}>
              Cancel
            </Button>
            <Button type="primary" onClick={() => submitContractFileFn()} loading={btnLoading} disabled={btnDisabled}>
              Submit
            </Button>
          </Space>
        </div>
      </Modal>
      <SubContractModal
        contractId={interfaceData?.contract?.id}
        projectId={interfaceData?.project?.id}
        id={subContractRowKey[0]}
        ref={subContractRef}
        submitInitFn={subContractModalSubmitFn}
      />
      <TradeModal
        contractId={interfaceData?.contract?.id}
        projectId={interfaceData?.project?.id}
        propId={interfaceData?.project?.propId}
        id={tradeRowKey[0]}
        ref={tradeRef}
        submitInitFn={tradeModalSubmitFn}
      />
      <TradeLinkPaidPayments
        contractId={interfaceData?.contract?.id}
        vendorId={interfaceData?.contract?.vendorId}
        projectId={interfaceData?.project?.id}
        propId={interfaceData?.project?.propId}
        ref={tradeLinkPaidPaymentsRef}
        submitInitFn={tradeModalSubmitFn}
      />
      {/* 部分参数修改 */}
      <ParamEditModal 
        ref={paramEditModalRef}
        record={paramEditRecord}
        paramEditModalSubmitlFn={(params) => paramEditModalSubmitlFn(params)}
      />
    </div>
  );
}
